import {createGate} from "effector-react";
import {createEvent} from "effector";

export const SectorsGate = createGate()

export const downloadSectorsEv = createEvent()
